import { all, call, put, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/callApi';
import { fetchAccountInformationSuccess } from 'redux/modules/account';
import { fetchAppInfoSuccess } from 'redux/modules/appInfo';
import { CREATE_PATIENT_SUCCESS } from 'redux/modules/patients';
import {
  CREATE_PATIENT_NOTE_SUCCESS,
  UPDATE_PATIENT_NOTE_SUCCESS,
  DELETE_PATIENT_NOTE_SUCCESS,
  ADD_PATIENT_NOTE_RESOURCE_SUCCESS,
  REMOVE_PATIENT_NOTE_RESOURCE_SUCCESS,
} from 'redux/modules/patientsNotes';
import {
  CREATE_ORDER_NOTE_SUCCESS,
  UPDATE_ORDER_NOTE_SUCCESS,
  DELETE_ORDER_NOTE_SUCCESS,
  ADD_ORDER_NOTE_RESOURCE_SUCCESS,
  REMOVE_ORDER_NOTE_RESOURCE_SUCCESS,
} from 'redux/modules/ordersNotes';

// Actions
export const FETCH_PATIENT_GLOBAL_NOTES = 'FETCH_PATIENT_GLOBAL_NOTES';
export const FETCH_PATIENT_GLOBAL_NOTES_SUCCESS = 'FETCH_PATIENT_GLOBAL_NOTES_SUCCESS';
export const FETCH_PATIENT_GLOBAL_NOTES_FAIL = 'FETCH_PATIENT_GLOBAL_NOTES_FAIL';

// Reducer
export default function patientsGlobalNotesReducer(state = {
  data: [], count: 0, loading: 0,
}, action) {
  const { type } = action;
  let triggerLoading;
  let payload;
  if (action.payload) {
    ({ triggerLoading, ...payload } = action.payload);
  }
  switch (type) {
    case FETCH_PATIENT_GLOBAL_NOTES:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading + 1 } : {},
      };
    case CREATE_PATIENT_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }
        return {
          ...dataItem,
          'Patient Global Notes': [],
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case FETCH_PATIENT_GLOBAL_NOTES_SUCCESS: {
      let newCount = state.count;
      const updatedData = state.data.map((dataItem) => {
        const newPatientGlobalNotes = payload.data.filter(payloadItem =>
          payloadItem['Record Number'] === dataItem['Record Number'])[0];
        if (!newPatientGlobalNotes) {
          return dataItem;
        }
        return {
          ...dataItem,
          'Patient Global Notes': newPatientGlobalNotes['Patient Global Notes'],
        };
      });
      const newData = payload.data.filter(payloadItem =>
        updatedData.filter(dataItem =>
          dataItem['Record Number'] === payloadItem['Record Number']).length === 0);
      newCount += newData.length;
      return {
        ...state,
        count: newCount,
        data: [
          ...updatedData,
          ...newData,
        ],
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    }
    case FETCH_PATIENT_GLOBAL_NOTES_FAIL:
      return {
        ...state,
        ...triggerLoading ? { loading: state.loading - 1 } : {},
      };
    case CREATE_PATIENT_NOTE_SUCCESS:
    case CREATE_ORDER_NOTE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (dataItem['Record Number'] !== payload['Record Number']) {
          return dataItem;
        }

        return {
          ...dataItem,
          'Patient Global Notes': [
            payload['Patient Notes'],
            ...dataItem['Patient Global Notes'],
          ],
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case UPDATE_PATIENT_NOTE_SUCCESS:
    case UPDATE_ORDER_NOTE_SUCCESS:
    case ADD_ORDER_NOTE_RESOURCE_SUCCESS:
    case REMOVE_ORDER_NOTE_RESOURCE_SUCCESS:
    case ADD_PATIENT_NOTE_RESOURCE_SUCCESS:
    case REMOVE_PATIENT_NOTE_RESOURCE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Patient Global Notes']) {
          return dataItem;
        }

        const newPatientGlobalNotes = dataItem['Patient Global Notes']
          .map((notesItem) => {
            if (notesItem.ID !== payload.ID) {
              return notesItem;
            }

            return {
              ...notesItem,
              ...payload,
            };
          });

        return {
          ...dataItem,
          'Patient Global Notes': newPatientGlobalNotes,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    case DELETE_PATIENT_NOTE_SUCCESS:
    case DELETE_ORDER_NOTE_SUCCESS: {
      const newData = state.data.map((dataItem) => {
        if (!dataItem['Patient Global Notes']) {
          return dataItem;
        }
        const index = dataItem['Patient Global Notes']
          .findIndex(item => item.ID === payload.ID);
        if (index === -1) {
          return dataItem;
        }
        const newPatientGlobalNotes = [
          ...dataItem['Patient Global Notes'].slice(0, index),
          ...dataItem['Patient Global Notes'].slice(index + 1),
        ];
        return {
          ...dataItem,
          'Patient Global Notes': newPatientGlobalNotes,
        };
      });
      return {
        ...state,
        data: newData,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export function fetchPatientGlobalNotes(payload) {
  return { type: FETCH_PATIENT_GLOBAL_NOTES, payload };
}

export function fetchPatientGlobalNotesSuccess(payload) {
  return { type: FETCH_PATIENT_GLOBAL_NOTES_SUCCESS, payload };
}

export function fetchPatientGlobalNotesFail(payload) {
  return { type: FETCH_PATIENT_GLOBAL_NOTES_FAIL, payload };
}

// Requests
export function requestFetchPatientGlobalNotes(payload) {
  return callApi('patient/global_notes/search/', 'POST', payload);
}

// Sagas
function* fetchPatientGlobalNotesSaga(action) {
  const {
    values,
    resolve,
    reject,
    triggerLoading,
  } = action.payload;
  try {
    const res = yield all(
      values['Record Number'].map(item => call(requestFetchPatientGlobalNotes, {
        'User Record Number': item,
        ...values['Is Delivery'] !== 'undefined' ? {
          'Is Delivery': values['Is Delivery'],
        } : {},
        filters: values.filters || [],
      })),
    );
    const resData = res.map((item, index) => ({
      'Patient Global Notes': item.data,
      'Record Number': Number(values['Record Number'][index]),
    }));
    yield put(fetchPatientGlobalNotesSuccess({
      data: resData,
      triggerLoading,
    }));
    yield put(fetchAccountInformationSuccess(res[0].user_info));
    yield put(fetchAppInfoSuccess(res.app_info));
    if (resolve) {
      resolve(resData);
    }
  } catch (err) {
    yield put(fetchPatientGlobalNotesFail({
      ...err.data,
      triggerLoading,
    }));
    if (reject) {
      reject(err.data);
    }
  }
}

export function* patientsGlobalNotesSaga() {
  yield takeEvery(FETCH_PATIENT_GLOBAL_NOTES, fetchPatientGlobalNotesSaga);
}



// WEBPACK FOOTER //
// ./src/redux/modules/patientsGlobalNotes.js